import { render } from "./ListArticleKindsActionButtonsRenderer.vue?vue&type=template&id=1b986a43"
import script from "./ListArticleKindsActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListArticleKindsActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__